var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPropertyType = function SvgPropertyType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    d: "M21.118 36.294H11.94v-9.177h9.177z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10.531 3.824v4.941M25.002 13.707H8.06v22.588H25zM10.883 16.531h.706M14.412 16.531h.706M17.941 16.531h.706M21.473 16.531h.706M10.883 19.356h.706M14.412 19.356h.706M17.941 19.356h.706M21.473 19.356h.706M24.295 8.059H25M27.824 8.059h.706M24.295 10.883H25M20.766 8.059h.706M20.766 10.883h.706M27.824 10.883h.706M27.824 13.707h.706M27.824 16.531h.706M27.824 19.356h.706M10.883 22.176h.706M14.412 22.176h.706M17.941 22.176h.706M21.473 22.176h.706M10.883 25h.706M14.412 25h.706M17.941 25h.706M21.473 25h.706"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M17.941 13.707v-12l13.412 3.53v16.94H25M27.824 25h.706M31.354 25h.705M27.824 27.824h.706M31.354 27.824h.705M27.824 30.648h.706M31.354 30.648h.705M27.824 33.473h.706M31.354 33.473h.705"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M34.884 22.176h-9.882v14.117h9.882z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M8.06 36.295H3.12V8.765h14.823v4.942H8.06v22.588Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M1.707 36.297h34.588"
  })));
};
export default SvgPropertyType;